import {mutationTypes} from '@/core/constants'

export default {

    [mutationTypes.PARAMETROS.SET_PARAMETROS](state, parametros) {
        state.parametros = parametros
    },

}
